import { Component, Input, OnInit } from '@angular/core';
import { TransactionItem, OutlineItem } from 'src/app/shared/models/base.models';

@Component({
  selector: 'app-transactions-list',
  templateUrl: './transactions-list.component.html',
  styleUrls: ['./transactions-list.component.css']
})
export class TransactionsListComponent implements OnInit {
  isListView: boolean = true;
  @Input() transactionsList: TransactionItem[] = []
  @Input() title: string;
  constructor() { }

  ngOnInit() {
  }

}
